import { render } from "./HospitalPaymentModal.vue?vue&type=template&id=062a2ae2&scoped=true"
import script from "./HospitalPaymentModal.vue?vue&type=script&lang=js"
export * from "./HospitalPaymentModal.vue?vue&type=script&lang=js"

import "./HospitalPaymentModal.vue?vue&type=style&index=0&id=062a2ae2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062a2ae2"]])

export default __exports__